export const CONTACTS_CREATE_MODAL_TOGGLE = 'CONTACTS_CREATE_MODAL_TOGGLE';
